export const COMPETENCY_SURVEY_STUDENT_STATUS = {
  SUBMITTED: 'Submitted',
  EVALUATED: 'Evaluated'
};